
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13618",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13618",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1335",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10175",
  "foundations-components": "static-1.8852",
  "foundations-components-legacy": "static-1.1877",
  "foundations-theming": "static-1.5041",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.96",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8582",
  "hub-http-shared-msw-handlers": "static-1.11009",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12029",
  "I18n": "static-7.1724",
  "jasmine-runner": "static-1.6998",
  "marketplace-discovery-studio-lib": "static-1.1009",
  "marketplace-storefront-base": "static-1.13681",
  "quartz": "static-1.7762",
  "react-dlb": "static-1.97",
  "react-rhumb": "static-1.17279",
  "reactive-variable-buffer-atom": "static-1.3389",
  "reporting-testing-lib": "static-1.11581",
  "reselect": "static-3.20",
  "settings-ui-lib": "static-1.13072",
  "SharedI18nStrings": "static-1.191",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7941",
  "ui-addon-i18n": "static-1.11687",
  "ui-addon-react-router-dom": "static-1.10068",
  "unified-auth": "static-1.1380",
  "unified-auth-core-lib": "static-1.1662",
  "usage-tracker": "static-1.7883",
  "usage-tracker-core": "static-1.7733",
  "customer-data-property-utils": "static-1.8599",
  "hub-http": "static-1.6745",
  "integrations-lib": "static-1.17566",
  "marketplace-ui-common": "static-1.21161",
  "marketplace-ui-install": "static-1.1147",
  "property-management-iframe": "static-1.14618",
  "quartz-config": "static-1.1540",
  "quartz-core": "static-1.6981",
  "quartz-routing": "static-1.1192",
  "quick-fetch": "static-1.4267",
  "react": "static-7.206",
  "rpc-client-utils": "static-1.5206",
  "ts-schema": "static-1.4433",
  "ui-universal-auth": "static-1.9866",
  "UIComponents": "static-3.8975",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4039",
  "quartz-webpack": "static-1.3986",
  "bend-plugin-quartz-routing": "static-1.840",
  "ai-components-ui-library": "static-1.10134",
  "codemirror": "static-5.109",
  "foundations-assets": "static-1.5429",
  "pulse": "static-1.1209",
  "react-codemirror": "static-1.11182",
  "ui-extensions-preview-lib": "static-1.1120",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5121",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2757",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9964",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.122",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5719",
  "react-virtualized": "static-2.115",
  "StyleGuideUI": "static-3.521",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3264",
  "ui-fonts": "static-1.1291",
  "ui-images": "static-2.1296",
  "bend-plugin-foundations-theming": "static-1.3524",
  "foundations-theming-base": "static-1.4026",
  "stylex": "static-1.49",
  "HeadJS": "static-2.837",
  "hs-test-utils-bend-plugin": "static-1.3693",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4845",
  "ui-addon-video-player": "static-1.9162",
  "ai-rendering-library": "static-1.11553",
  "chirp-fetch": "static-1.2440",
  "connections-embed-lib": "static-1.1851",
  "copilot-toolkit": "static-1.12271",
  "feedback-loader": "static-1.30153",
  "laboratory-lib": "static-3.7688",
  "marketplace-embed": "static-1.23314",
  "marketplace-ui-details": "static-1.11056",
  "marketplace-ui-reviews": "static-1.21116",
  "marketplace-ui-tracking": "static-1.15331",
  "sanitize-text": "static-1.8697",
  "usage-tracker-multi": "static-1.6297",
  "usage-tracker-session-replay": "static-1.5569",
  "beacon-keepalive-queue": "static-1.242",
  "quartz-head": "static-1.1427",
  "web-vitals": "static-1.22",
  "apollo-link-hub-http": "static-2.5129",
  "immer": "static-1.107",
  "immerable": "static-1.4684",
  "highcharts": "static-8.118",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2902",
  "reporting-data": "static-1.69648",
  "cssUtils": "static-1.1163",
  "flux-actions": "static-1.384",
  "react-colorpicker": "static-2.10749",
  "react-dnd-compat": "static-1.5150",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10912",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7873",
  "icons": "static-2.716",
  "marketplace-ui-apps-core": "static-1.19693",
  "storybook-react": "static-1.47",
  "trellis-story-utils": "static-1.5036",
  "foundations-components-test-utils": "static-1.6335",
  "quartz-i18n": "static-1.1437",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.852",
  "ads-unified-auth-lib": "static-1.2315",
  "ai-mcp-auth-lib": "static-1.87",
  "cohere-settings-lib": "static-1.10552",
  "custom-vendor-connection-lib": "static-1.430",
  "gemini-settings-lib": "static-1.9901",
  "google-sheets-integration-lib": "static-1.1449",
  "microsoft-drive-auth-lib": "static-1.649",
  "slack-ui-library": "static-1.10942",
  "surveymonkey-integration-lib": "static-1.964",
  "x-ai-settings-lib": "static-1.10609",
  "fsm": "static-1.4301",
  "customer-data-objects": "static-1.8254",
  "property-translator": "static-1.5915",
  "hs-locale-management": "static-1.442",
  "frontend-preferences-client": "static-1.8463",
  "hs-promise-utils": "static-1.6130",
  "hubspot-apollo-client": "static-1.5416",
  "integrations-error-boundary-lib": "static-1.14981",
  "integrations-tracking-lib": "static-1.6168",
  "native-integrations-shared-strings": "static-1.8298",
  "sanitize": "static-1.5008",
  "superstore": "static-1.5295",
  "ui-shepherd-react": "static-3.10827",
  "ai-settings-ui-library": "static-1.8689",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "immutable-less": "static-1.5188",
  "marketplace-ui-client-types": "static-1.18568",
  "nav-meta": "static-1.30965",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18611",
  "ui-product-approvals-common": "static-1.1815",
  "ai-studio-lib": "static-1.12923",
  "hubspot-prosemirror": "static-1.19407",
  "integrations-reconnect-lib": "static-1.824",
  "ui-addon-iframeable": "static-1.9620",
  "ui-addon-integrations-directory-panel": "static-2.8489",
  "ui-product-approvals": "static-1.29919",
  "ui-tool-access": "static-1.10694",
  "data-agent-kit": "static-1.1057",
  "inbound-db-properties-service-client": "static-1.4190",
  "property-management-common": "static-1.6906",
  "smart-property-fill-lib": "static-1.878",
  "opentelemetry-fe-types": "static-1.340",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.18",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.715",
  "quartz-auth": "static-1.1437",
  "quartz-test": "static-1.1437",
  "quartz-tracking": "static-1.1141",
  "trellis-components": "static-1.3283",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.616",
  "HubStyle": "static-2.12336",
  "bender-build-tools": "static-1.3648",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24286",
  "ContentUtils": "static-1.69624",
  "customer-data-objects-ui-components": "static-1.13576",
  "sassPrefix": "static-1.427",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2091",
  "bend-plugin-pulse": "static-1.712",
  "event-emitter": "static-1.1500",
  "fast-json-patch": "static-1.77",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5963",
  "magpie-types": "static-1.5423",
  "stylex-utils": "static-1.191",
  "trellis-theming": "static-1.1583",
  "avatar-components": "static-1.3028",
  "breeze-engine-core": "static-1.1672",
  "breeze-engine-lib": "static-1.2394",
  "breeze-onboarding-components": "static-1.1218",
  "breeze-upgrade-component-lib": "static-1.55",
  "customer-data-filters-ui": "static-1.41553",
  "customer-data-reference-ui-components": "static-1.13716",
  "data-integrations-breeze": "static-1.561",
  "embedded-academy-lib": "static-1.16218",
  "ExportDialog": "static-6.10914",
  "global-styles-ai-lib": "static-1.607",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.1017",
  "mermaid": "static-1.48",
  "reporting-action-components": "static-1.42533",
  "reporting-snowflake": "static-1.58264",
  "reporting-ui-components": "static-2.66917",
  "reporting-visualizations": "static-1.61722",
  "trial-components-library": "static-1.14486",
  "ui-addon-teams": "static-1.22079",
  "upgrade-components-lib": "static-1.798",
  "navigation-components": "static-1.19328",
  "nest": "static-1.778",
  "simple-logging-lib": "static-1.3587",
  "nudge-client-utils": "static-1.3515",
  "fail-safe": "static-1.486",
  "app-governance-lib": "static-1.2848",
  "developer-experience-shared-components": "static-1.11085",
  "purchase-motions-components": "static-1.6723",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10979",
  "usage-tracker-anonymous": "static-1.6300",
  "usage-tracker-public": "static-1.7694",
  "amplitude-session-replay-browser": "static-1.80",
  "inbound-db-meta-service-client": "static-1.3810",
  "persist-promise": "static-1.4248",
  "reference-resolvers": "static-1.8726",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4458",
  "hubspot-apollo-cache": "static-1.875",
  "universal-page-editor-lib": "static-1.3560",
  "final-form": "static-1.86",
  "redux-toolkit": "static-1.85",
  "simple-data-table": "static-1.3945",
  "merchandise-lib": "static-1.291",
  "onboarding-scopes": "static-1.6992",
  "permissions-summary-ui-lib": "static-1.176",
  "ui-addon-draggable": "static-3.5292",
  "content-assistance-lib": "static-1.8507",
  "content-media-capture": "static-1.5892",
  "customer-data-ui-utilities": "static-1.10373",
  "emoji-mart": "static-3.10",
  "file-manager-components": "static-1.24940",
  "growth-payments-core": "static-1.26634",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3415",
  "payment-link-components": "static-1.24592",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20649",
  "ui-addon-emoji-picker": "static-1.10404",
  "ui-business-units-lib": "static-1.9636",
  "video-components-external": "static-1.12556",
  "video-data-lib": "static-1.36214",
  "navigation-messaging": "static-1.8655",
  "collaboration-sidebar": "static-1.59179",
  "trellis-ext-dnd": "static-1.640",
  "policy-lib": "static-1.7344",
  "crm-component-utils": "static-1.40343",
  "crm-properties-common-lib": "static-1.6437",
  "customer-data-properties": "static-1.53254",
  "external-options-client-types": "static-1.4478",
  "hs-resources": "static-1.736",
  "property-value-citations": "static-1.3868",
  "reference-resolvers-lite": "static-1.8653",
  "access-check-ui-lib": "static-1.2074",
  "crm-message-bus": "static-1.44259",
  "data-agent-test-utils": "static-1.601",
  "data-agent-usage-based-billing": "static-1.244",
  "data-agent-utils": "static-1.1070",
  "enrichment-settings-lib": "static-1.416",
  "smart-property-lib": "static-1.8860",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11007",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "cms-field-types": "static-1.5353",
  "content-icons-ui": "static-1.2524",
  "atom": "static-1.5613",
  "idb-keyval": "static-1.58",
  "reactive-lib": "static-1.1262",
  "trellis-migration-context": "static-1.118",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1372",
  "breeze-artifacts-sdk": "static-1.1221",
  "breeze-assistant-components": "static-1.2774",
  "getting-started-shared-tasks": "static-1.19667",
  "onboarding-journeys-lib": "static-1.1357",
  "interactive-cards": "static-1.623",
  "conversations-skeleton-state": "static-1.7653",
  "customer-data-filters-ui-msw-helpers": "static-1.23988",
  "events-data-lib": "static-1.793",
  "FormUrlGenerator": "static-2.5254",
  "framework-builder-read-service-client": "static-1.4374",
  "multi-account-reference-resolvers": "static-1.1561",
  "onboarding-tours": "static-1.17486",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14878",
  "segments-client-types": "static-1.12395",
  "academy-common-lib": "static-1.15679",
  "dashboard-lib": "static-1.83466",
  "hubspot-prosemirror-plugins": "static-1.19399",
  "reporting-plugins": "static-1.11107",
  "share-with-third-party-component-lib": "static-1.9254",
  "ui-addon-draggable-compat": "static-2.4801",
  "ui-asset-management-lib": "static-1.11649",
  "user-context": "static-1.5598",
  "reporting-reports": "static-1.69324",
  "hubs-service-types": "static-1.1806",
  "purchase-motions-api": "static-1.6726",
  "salesImages": "static-1.798",
  "signup-constants": "static-1.20121",
  "nudge-custom-function-registry": "static-1.3272",
  "nudge-renderer-utils": "static-1.3591",
  "whisper-core-api": "static-1.7745",
  "bend-plugin-fail-safe": "static-1.437",
  "framework-listing-lib": "static-2.29952",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31883",
  "apps-service-types": "static-1.4148",
  "oauth-service-types": "static-1.4676",
  "signup-ui-url-generator": "static-2.8575",
  "onboarding-tours-client": "static-1.5701",
  "one-click-checkout": "static-1.877",
  "platform-infra-nav-components": "static-1.8039",
  "purchasing-components-lib": "static-1.1127",
  "subscription-experience-data-types": "static-1.15522",
  "crm-record-cards-client": "static-1.235",
  "crm-record-cards-service-types": "static-1.3895",
  "framework-data-schema-resolvers": "static-1.7432",
  "location-customization-utils-lib": "static-1.10563",
  "redux-thunk": "static-2.88",
  "seat-types-lib": "static-1.1177",
  "react-flip-move": "static-1.86",
  "ui-coaching-tips": "static-1.29643",
  "content-media-composition-data-lib": "static-1.13696",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4969",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.4016",
  "ui-addon-opt": "static-4.8976",
  "commerce-tours-lib": "static-1.6954",
  "growth-onboarding-reliability": "static-1.5623",
  "sales-checkout-service-client": "static-1.4062",
  "data-token-picker": "static-1.17228",
  "FileManagerLib": "static-1.40580",
  "content-media-compositions": "static-2.17703",
  "media-bridge-lib": "static-1.19734",
  "chatspot-widget-iframe": "static-1.24277",
  "collaboration-sidebar-common": "static-1.3976",
  "marketing-platform-lib": "static-1.7451",
  "dnd-kit": "static-1.24",
  "commerce-subscription-lib": "static-1.38174",
  "crm-actions": "static-1.6955",
  "crm-cards-sdk": "static-1.45206",
  "customer-data-properties-shared-msw-handlers": "static-1.10336",
  "customer-data-tracking": "static-1.7411",
  "calling-global-api": "static-1.66525",
  "calling-internal-common": "static-1.31863",
  "calling-lifecycle-internal": "static-1.67907",
  "calling-lifecycle-messages": "static-1.60199",
  "commerce-products-lib": "static-1.11100",
  "conditional-properties-service-client": "static-1.4150",
  "crm-index-visualization-core": "static-1.4852",
  "crm-links": "static-1.6867",
  "crm-pipelines-api-client-types": "static-1.4484",
  "formula-editor": "static-1.15086",
  "google-libphonenumber": "static-1.53",
  "inbounddb-objects-service-types": "static-1.4554",
  "meetings-icalendar-utils-lib": "static-1.1175",
  "multi-currency-client-types": "static-1.4049",
  "object-builder-ui-client": "static-1.50225",
  "pipeline-validation-client-types": "static-1.4322",
  "react-tinymce": "static-1.56378",
  "smart-data-capture-core": "static-1.618",
  "tiered-pricing": "static-1.2392",
  "tinymce-config": "static-2.55504",
  "tinymce-plugins": "static-1.58618",
  "tinymce-themes": "static-1.57474",
  "topics-actions-lib": "static-1.733",
  "trellis-ext-i18n": "static-1.1484",
  "ui-addon-form-validation": "static-1.11353",
  "zustand": "static-1.93",
  "fdsr-migration-layer": "static-1.554",
  "permissions-shared-i18n-strings-fe": "static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11092",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11155",
  "sales-views-client-types": "static-1.4798",
  "breeze-sharing-core": "static-1.102",
  "dompurify": "static-1.17",
  "utility-belt": "static-1.3075",
  "growth-data-modal": "static-1.6222",
  "growth-onboarding-confetti": "static-1.3596",
  "growth-onboarding-next-action-utils": "static-1.3104",
  "onboarding-tours-utils": "static-1.1553",
  "ui-shepherd-tracker": "static-1.8208",
  "crm-index-associations-lib": "static-1.6990",
  "academy-service-client": "static-1.4233",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40439",
  "SafeStorage": "static-1.4935",
  "video-embed": "static-1.37048",
  "redux-actions": "static-3.77",
  "EmailSignatureEditor": "static-1.25353",
  "viral-links-lib": "static-1.7623",
  "campaign-roi-lib": "static-1.11030",
  "campaigns-utils-lib": "static-1.3811",
  "ui-addon-calendars": "static-2.5912",
  "nested-table": "static-1.762",
  "timezone-utils": "static-2.5766",
  "getting-started-shared-tasks-store": "static-1.18785",
  "customer-data-views-management": "static-1.26465",
  "framework-data-table": "static-2.12950",
  "nudge-custom-ui-functions": "static-1.1824",
  "switchboard-lib": "static-1.786",
  "app-users-service-client": "static-1.6160",
  "app-users-service-types": "static-1.5568",
  "mini-checkout-client": "static-1.27972",
  "onboarding-utils": "static-1.5915",
  "ui-coaching-tips-shared-config": "static-1.29628",
  "checkout-sdk": "static-3.24815",
  "payment-method-components": "static-1.7380",
  "touchless-buying-components": "static-1.6683",
  "upgrade-catalog-service-types": "static-1.3908",
  "pricing-pages-ui-components": "static-1.16838",
  "edison-service-client-types": "static-1.931",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "growth-onboarding-feedback-components": "static-1.7125",
  "audio-components": "static-1.6654",
  "FileManagerImages": "static-1.38091",
  "video-components": "static-1.14558",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20627",
  "commerce-shared-components-lib": "static-1.19699",
  "commerce-tools-ui-lib": "static-1.11437",
  "crm_data": "static-4.93364",
  "crm-activity-creator-data": "static-1.47919",
  "crm-fe-perf": "static-1.23442",
  "universal-record-utils-lib": "static-1.2509",
  "calling-error-reporting": "static-1.31870",
  "shared-worker-versioning": "static-1.11580",
  "calling-usage-tracker": "static-1.7081",
  "voice-sms-access-library": "static-1.2617",
  "commerce-permissions": "static-1.1323",
  "products-iframe-lib": "static-1.9062",
  "products-ui-components-shared-msw-handlers": "static-1.11391",
  "bark-lib": "static-1.17074",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3570",
  "interframe": "static-3.5285",
  "tinymce-data": "static-1.41589",
  "ui-addon-sales-email": "static-1.5747",
  "layout-dnd-components": "static-1.13323",
  "layout-dnd-utils": "static-1.12298",
  "ui-brand-identity-lib": "static-1.17103",
  "NamespacedHubStyle": "static-2.9407",
  "onboarding-data-sync-lib": "static-1.2926",
  "growth-onboarding-next-action-components": "static-1.3132",
  "user-context-client": "static-1.5047",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5057",
  "outpost": "static-1.4665",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22454",
  "sales-email-signature-service-client": "static-1.4386",
  "copilot-messaging": "static-1.2521",
  "ts-utils-lib": "static-1.695",
  "crm-export-dialog": "static-1.6819",
  "crm-index-ui-shimmer": "static-1.3138",
  "crm-view-components": "static-1.1658",
  "react-beautiful-dnd": "static-1.78",
  "customer-data-associations": "static-1.7884",
  "tasks-actions-lib": "static-1.566",
  "InboxConnectUtils": "static-4.15962",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.895",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4531",
  "company-details-components": "static-1.6749",
  "react-performance-metrics-lib": "static-1.1091",
  "quote-checkout-service-types": "static-1.4000",
  "pricing-pages-api": "static-1.16704",
  "social-insights-client-types": "static-1.23049",
  "crm-command-handler-types": "static-1.197",
  "payments-enrollment-embed-lib": "static-1.24407",
  "stripe-embedded-components": "static-1.8338",
  "customer-data-rte": "static-1.34006",
  "cv-backend-services": "static-1.1622",
  "growth-onboarding-empty-states": "static-1.6632",
  "payments-post-enroll-local-storage-lib": "static-1.5640",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39296",
  "crm_universal": "static-1.22815",
  "customer-data-email": "static-1.18739",
  "meetings-rte-lib": "static-1.641",
  "universal-associations-select": "static-1.11645",
  "crm-object-search-query-utilities": "static-1.10570",
  "calling-orchestration-schema": "static-1.37394",
  "react-reducer-toolkit": "static-1.16777",
  "ContentData": "static-1.69699",
  "layout-data-lib": "static-1.10623",
  "meetings-connect-utils-lib": "static-1.8159",
  "company-details-service-types": "static-1.4480",
  "segments-query-core": "static-1.1967",
  "stripe-connect-js": "static-1.86",
  "draft-content-plugins": "static-1.29258",
  "sequences-lib": "static-1.8875",
  "ui-gdpr-components": "static-1.10659",
  "meetings-client-types": "static-1.4128",
  "meetings-core": "static-1.863",
  "advanced-menus-core": "static-1.15914",
  "advanced-menus-lib": "static-1.12642",
  "ui-memberships-settings-lib": "static-1.35334",
  "sequences-client-types-lib": "static-1.8732",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15913",
  "simple-menus-lib": "static-1.17430"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13618",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1335",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10175",
  "foundations-components": "/foundations-components/static-1.8852",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1877",
  "foundations-theming": "/foundations-theming/static-1.5041",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.96",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8582",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11009",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12029",
  "I18n": "/I18n/static-7.1724",
  "jasmine-runner": "/jasmine-runner/static-1.6998",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.1009",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13681",
  "quartz": "/quartz/static-1.7762",
  "react-dlb": "/react-dlb/static-1.97",
  "react-rhumb": "/react-rhumb/static-1.17279",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3389",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11581",
  "reselect": "/reselect/static-3.20",
  "settings-ui-lib": "/settings-ui-lib/static-1.13072",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7941",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11687",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10068",
  "unified-auth": "/unified-auth/static-1.1380",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1662",
  "usage-tracker": "/usage-tracker/static-1.7883",
  "usage-tracker-core": "/usage-tracker-core/static-1.7733",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8599",
  "hub-http": "/hub-http/static-1.6745",
  "integrations-lib": "/integrations-lib/static-1.17566",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21161",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1147",
  "property-management-iframe": "/property-management-iframe/static-1.14618",
  "quartz-config": "/quartz-config/static-1.1540",
  "quartz-core": "/quartz-core/static-1.6981",
  "quartz-routing": "/quartz-routing/static-1.1192",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "react": "/react/static-7.206",
  "rpc-client-utils": "/rpc-client-utils/static-1.5206",
  "ts-schema": "/ts-schema/static-1.4433",
  "ui-universal-auth": "/ui-universal-auth/static-1.9866",
  "UIComponents": "/UIComponents/static-3.8975",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4039",
  "quartz-webpack": "/quartz-webpack/static-1.3986",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.840",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10134",
  "codemirror": "/codemirror/static-5.109",
  "foundations-assets": "/foundations-assets/static-1.5429",
  "pulse": "/pulse/static-1.1209",
  "react-codemirror": "/react-codemirror/static-1.11182",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1120",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5121",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2757",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9964",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.122",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5719",
  "react-virtualized": "/react-virtualized/static-2.115",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3264",
  "ui-fonts": "/ui-fonts/static-1.1291",
  "ui-images": "/ui-images/static-2.1296",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3524",
  "foundations-theming-base": "/foundations-theming-base/static-1.4026",
  "stylex": "/stylex/static-1.49",
  "HeadJS": "/HeadJS/static-2.837",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3693",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4845",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9162",
  "ai-rendering-library": "/ai-rendering-library/static-1.11553",
  "chirp-fetch": "/chirp-fetch/static-1.2440",
  "connections-embed-lib": "/connections-embed-lib/static-1.1851",
  "copilot-toolkit": "/copilot-toolkit/static-1.12271",
  "feedback-loader": "/feedback-loader/static-1.30153",
  "laboratory-lib": "/laboratory-lib/static-3.7688",
  "marketplace-embed": "/marketplace-embed/static-1.23314",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.11056",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21116",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15331",
  "sanitize-text": "/sanitize-text/static-1.8697",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6297",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5569",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.242",
  "quartz-head": "/quartz-head/static-1.1427",
  "web-vitals": "/web-vitals/static-1.22",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5129",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4684",
  "highcharts": "/highcharts/static-8.118",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2902",
  "reporting-data": "/reporting-data/static-1.69648",
  "cssUtils": "/cssUtils/static-1.1163",
  "flux-actions": "/flux-actions/static-1.384",
  "react-colorpicker": "/react-colorpicker/static-2.10749",
  "react-dnd-compat": "/react-dnd-compat/static-1.5150",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10912",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7873",
  "icons": "/icons/static-2.716",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19693",
  "storybook-react": "/storybook-react/static-1.47",
  "trellis-story-utils": "/trellis-story-utils/static-1.5036",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6335",
  "quartz-i18n": "/quartz-i18n/static-1.1437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.852",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2315",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.87",
  "cohere-settings-lib": "/cohere-settings-lib/static-1.10552",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.430",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9901",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1449",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.649",
  "slack-ui-library": "/slack-ui-library/static-1.10942",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.964",
  "x-ai-settings-lib": "/x-ai-settings-lib/static-1.10609",
  "fsm": "/fsm/static-1.4301",
  "customer-data-objects": "/customer-data-objects/static-1.8254",
  "property-translator": "/property-translator/static-1.5915",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8463",
  "hs-promise-utils": "/hs-promise-utils/static-1.6130",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5416",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14981",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6168",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8298",
  "sanitize": "/sanitize/static-1.5008",
  "superstore": "/superstore/static-1.5295",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10827",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8689",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "immutable-less": "/immutable-less/static-1.5188",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18568",
  "nav-meta": "/nav-meta/static-1.30965",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18611",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1815",
  "ai-studio-lib": "/ai-studio-lib/static-1.12923",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19407",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.824",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9620",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8489",
  "ui-product-approvals": "/ui-product-approvals/static-1.29919",
  "ui-tool-access": "/ui-tool-access/static-1.10694",
  "data-agent-kit": "/data-agent-kit/static-1.1057",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "property-management-common": "/property-management-common/static-1.6906",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.878",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.340",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.715",
  "quartz-auth": "/quartz-auth/static-1.1437",
  "quartz-test": "/quartz-test/static-1.1437",
  "quartz-tracking": "/quartz-tracking/static-1.1141",
  "trellis-components": "/trellis-components/static-1.3283",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.616",
  "HubStyle": "/HubStyle/static-2.12336",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24286",
  "ContentUtils": "/ContentUtils/static-1.69624",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13576",
  "sassPrefix": "/sassPrefix/static-1.427",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2091",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.712",
  "event-emitter": "/event-emitter/static-1.1500",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5963",
  "magpie-types": "/magpie-types/static-1.5423",
  "stylex-utils": "/stylex-utils/static-1.191",
  "trellis-theming": "/trellis-theming/static-1.1583",
  "avatar-components": "/avatar-components/static-1.3028",
  "breeze-engine-core": "/breeze-engine-core/static-1.1672",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2394",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1218",
  "breeze-upgrade-component-lib": "/breeze-upgrade-component-lib/static-1.55",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41553",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13716",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.561",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16218",
  "ExportDialog": "/ExportDialog/static-6.10914",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.607",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.1017",
  "mermaid": "/mermaid/static-1.48",
  "reporting-action-components": "/reporting-action-components/static-1.42533",
  "reporting-snowflake": "/reporting-snowflake/static-1.58264",
  "reporting-ui-components": "/reporting-ui-components/static-2.66917",
  "reporting-visualizations": "/reporting-visualizations/static-1.61722",
  "trial-components-library": "/trial-components-library/static-1.14486",
  "ui-addon-teams": "/ui-addon-teams/static-1.22079",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.798",
  "navigation-components": "/navigation-components/static-1.19328",
  "nest": "/nest/static-1.778",
  "simple-logging-lib": "/simple-logging-lib/static-1.3587",
  "nudge-client-utils": "/nudge-client-utils/static-1.3515",
  "fail-safe": "/fail-safe/static-1.486",
  "app-governance-lib": "/app-governance-lib/static-1.2848",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11085",
  "purchase-motions-components": "/purchase-motions-components/static-1.6723",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10979",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6300",
  "usage-tracker-public": "/usage-tracker-public/static-1.7694",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "persist-promise": "/persist-promise/static-1.4248",
  "reference-resolvers": "/reference-resolvers/static-1.8726",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4458",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.875",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3560",
  "final-form": "/final-form/static-1.86",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "simple-data-table": "/simple-data-table/static-1.3945",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "onboarding-scopes": "/onboarding-scopes/static-1.6992",
  "permissions-summary-ui-lib": "/permissions-summary-ui-lib/static-1.176",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5292",
  "content-assistance-lib": "/content-assistance-lib/static-1.8507",
  "content-media-capture": "/content-media-capture/static-1.5892",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10373",
  "emoji-mart": "/emoji-mart/static-3.10",
  "file-manager-components": "/file-manager-components/static-1.24940",
  "growth-payments-core": "/growth-payments-core/static-1.26634",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3415",
  "payment-link-components": "/payment-link-components/static-1.24592",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20649",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10404",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9636",
  "video-components-external": "/video-components-external/static-1.12556",
  "video-data-lib": "/video-data-lib/static-1.36214",
  "navigation-messaging": "/navigation-messaging/static-1.8655",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59179",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.640",
  "policy-lib": "/policy-lib/static-1.7344",
  "crm-component-utils": "/crm-component-utils/static-1.40343",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6437",
  "customer-data-properties": "/customer-data-properties/static-1.53254",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "hs-resources": "/hs-resources/static-1.736",
  "property-value-citations": "/property-value-citations/static-1.3868",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8653",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.2074",
  "crm-message-bus": "/crm-message-bus/static-1.44259",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.601",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.244",
  "data-agent-utils": "/data-agent-utils/static-1.1070",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.416",
  "smart-property-lib": "/smart-property-lib/static-1.8860",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11007",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "cms-field-types": "/cms-field-types/static-1.5353",
  "content-icons-ui": "/content-icons-ui/static-1.2524",
  "atom": "/atom/static-1.5613",
  "idb-keyval": "/idb-keyval/static-1.58",
  "reactive-lib": "/reactive-lib/static-1.1262",
  "trellis-migration-context": "/trellis-migration-context/static-1.118",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1372",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1221",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2774",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19667",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1357",
  "interactive-cards": "/interactive-cards/static-1.623",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7653",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23988",
  "events-data-lib": "/events-data-lib/static-1.793",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5254",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1561",
  "onboarding-tours": "/onboarding-tours/static-1.17486",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14878",
  "segments-client-types": "/segments-client-types/static-1.12395",
  "academy-common-lib": "/academy-common-lib/static-1.15679",
  "dashboard-lib": "/dashboard-lib/static-1.83466",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19399",
  "reporting-plugins": "/reporting-plugins/static-1.11107",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9254",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4801",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11649",
  "user-context": "/user-context/static-1.5598",
  "reporting-reports": "/reporting-reports/static-1.69324",
  "hubs-service-types": "/hubs-service-types/static-1.1806",
  "purchase-motions-api": "/purchase-motions-api/static-1.6726",
  "salesImages": "/salesImages/static-1.798",
  "signup-constants": "/signup-constants/static-1.20121",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3272",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3591",
  "whisper-core-api": "/whisper-core-api/static-1.7745",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.437",
  "framework-listing-lib": "/framework-listing-lib/static-2.29952",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31883",
  "apps-service-types": "/apps-service-types/static-1.4148",
  "oauth-service-types": "/oauth-service-types/static-1.4676",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8575",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5701",
  "one-click-checkout": "/one-click-checkout/static-1.877",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8039",
  "purchasing-components-lib": "/purchasing-components-lib/static-1.1127",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15522",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.235",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3895",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10563",
  "redux-thunk": "/redux-thunk/static-2.88",
  "seat-types-lib": "/seat-types-lib/static-1.1177",
  "react-flip-move": "/react-flip-move/static-1.86",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29643",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13696",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4969",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.4016",
  "ui-addon-opt": "/ui-addon-opt/static-4.8976",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6954",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5623",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4062",
  "data-token-picker": "/data-token-picker/static-1.17228",
  "FileManagerLib": "/FileManagerLib/static-1.40580",
  "content-media-compositions": "/content-media-compositions/static-2.17703",
  "media-bridge-lib": "/media-bridge-lib/static-1.19734",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24277",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3976",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7451",
  "dnd-kit": "/dnd-kit/static-1.24",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38174",
  "crm-actions": "/crm-actions/static-1.6955",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45206",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10336",
  "customer-data-tracking": "/customer-data-tracking/static-1.7411",
  "calling-global-api": "/calling-global-api/static-1.66525",
  "calling-internal-common": "/calling-internal-common/static-1.31863",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67907",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60199",
  "commerce-products-lib": "/commerce-products-lib/static-1.11100",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4150",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4852",
  "crm-links": "/crm-links/static-1.6867",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "formula-editor": "/formula-editor/static-1.15086",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4554",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1175",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50225",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "react-tinymce": "/react-tinymce/static-1.56378",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.618",
  "tiered-pricing": "/tiered-pricing/static-1.2392",
  "tinymce-config": "/tinymce-config/static-2.55504",
  "tinymce-plugins": "/tinymce-plugins/static-1.58618",
  "tinymce-themes": "/tinymce-themes/static-1.57474",
  "topics-actions-lib": "/topics-actions-lib/static-1.733",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1484",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "zustand": "/zustand/static-1.93",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.554",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11092",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11155",
  "sales-views-client-types": "/sales-views-client-types/static-1.4798",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.102",
  "dompurify": "/dompurify/static-1.17",
  "utility-belt": "/utility-belt/static-1.3075",
  "growth-data-modal": "/growth-data-modal/static-1.6222",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3596",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3104",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1553",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8208",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6990",
  "academy-service-client": "/academy-service-client/static-1.4233",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40439",
  "SafeStorage": "/SafeStorage/static-1.4935",
  "video-embed": "/video-embed/static-1.37048",
  "redux-actions": "/redux-actions/static-3.77",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25353",
  "viral-links-lib": "/viral-links-lib/static-1.7623",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.11030",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3811",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5912",
  "nested-table": "/nested-table/static-1.762",
  "timezone-utils": "/timezone-utils/static-2.5766",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18785",
  "customer-data-views-management": "/customer-data-views-management/static-1.26465",
  "framework-data-table": "/framework-data-table/static-2.12950",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1824",
  "switchboard-lib": "/switchboard-lib/static-1.786",
  "app-users-service-client": "/app-users-service-client/static-1.6160",
  "app-users-service-types": "/app-users-service-types/static-1.5568",
  "mini-checkout-client": "/mini-checkout-client/static-1.27972",
  "onboarding-utils": "/onboarding-utils/static-1.5915",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29628",
  "checkout-sdk": "/checkout-sdk/static-3.24815",
  "payment-method-components": "/payment-method-components/static-1.7380",
  "touchless-buying-components": "/touchless-buying-components/static-1.6683",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3908",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16838",
  "edison-service-client-types": "/edison-service-client-types/static-1.931",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7125",
  "audio-components": "/audio-components/static-1.6654",
  "FileManagerImages": "/FileManagerImages/static-1.38091",
  "video-components": "/video-components/static-1.14558",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20627",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19699",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11437",
  "crm_data": "/crm_data/static-4.93364",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47919",
  "crm-fe-perf": "/crm-fe-perf/static-1.23442",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2509",
  "calling-error-reporting": "/calling-error-reporting/static-1.31870",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11580",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7081",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2617",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "products-iframe-lib": "/products-iframe-lib/static-1.9062",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11391",
  "bark-lib": "/bark-lib/static-1.17074",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3570",
  "interframe": "/interframe/static-3.5285",
  "tinymce-data": "/tinymce-data/static-1.41589",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5747",
  "layout-dnd-components": "/layout-dnd-components/static-1.13323",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12298",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17103",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9407",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2926",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3132",
  "user-context-client": "/user-context-client/static-1.5047",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5057",
  "outpost": "/outpost/static-1.4665",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22454",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4386",
  "copilot-messaging": "/copilot-messaging/static-1.2521",
  "ts-utils-lib": "/ts-utils-lib/static-1.695",
  "crm-export-dialog": "/crm-export-dialog/static-1.6819",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3138",
  "crm-view-components": "/crm-view-components/static-1.1658",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.78",
  "customer-data-associations": "/customer-data-associations/static-1.7884",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.566",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15962",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.895",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4531",
  "company-details-components": "/company-details-components/static-1.6749",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1091",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.4000",
  "pricing-pages-api": "/pricing-pages-api/static-1.16704",
  "social-insights-client-types": "/social-insights-client-types/static-1.23049",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.197",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24407",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8338",
  "customer-data-rte": "/customer-data-rte/static-1.34006",
  "cv-backend-services": "/cv-backend-services/static-1.1622",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6632",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5640",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39296",
  "crm_universal": "/crm_universal/static-1.22815",
  "customer-data-email": "/customer-data-email/static-1.18739",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.641",
  "universal-associations-select": "/universal-associations-select/static-1.11645",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10570",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37394",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16777",
  "ContentData": "/ContentData/static-1.69699",
  "layout-data-lib": "/layout-data-lib/static-1.10623",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8159",
  "company-details-service-types": "/company-details-service-types/static-1.4480",
  "segments-query-core": "/segments-query-core/static-1.1967",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "draft-content-plugins": "/draft-content-plugins/static-1.29258",
  "sequences-lib": "/sequences-lib/static-1.8875",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "meetings-client-types": "/meetings-client-types/static-1.4128",
  "meetings-core": "/meetings-core/static-1.863",
  "advanced-menus-core": "/advanced-menus-core/static-1.15914",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12642",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35334",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8732",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15913",
  "simple-menus-lib": "/simple-menus-lib/static-1.17430"
}
};
